import {Serializable} from "./serializable";

export interface InstallerListInt {
  email: string;
  id: string;
  name: string;
  phone: string;
}

export class InstallerList implements Serializable<InstallerList> {

  email: string;
  id: string;
  name: string;
  phone: string;

  deserialize(input: any): InstallerList {
    if (!input) return null;

    this.id = input.id;
    this.name = input.name;
    this.email = input.email;
    this.phone = input.phone;

    console.log("input: ", this);
    return this;
  }

  flatten(): InstallerListInt {
    return {
      email: this.email,
      id: this.id,
      name: this.name,
      phone: this.phone
    };
  }

}

export class InstallerDetail implements Serializable<InstallerDetail> {

  email: string;
  id: string;
  name: string;
  phone: string;
  automations: any;

  deserialize(input: any): InstallerDetail {
    if (!input) return null;

    this.email = input.email;
    this.name = input.name;
    this.id = input.id;
    this.phone = input.phone;
    this.automations = input.automations;

    return this;
  }

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/models/installer.ts